import type { P2PModuleEntitlement } from './types';

export const P2P_ENABLED_ENTITLEMENT: P2PModuleEntitlement = {
  enabled: true,
  source: 'demo',
};

export const P2P_DISABLED_ENTITLEMENT: P2PModuleEntitlement = {
  enabled: false,
  source: 'app_config',
  reason: 'P2P module is turned off for this client.',
};

export function isP2PModuleEnabled(entitlement: P2PModuleEntitlement | null | undefined): boolean {
  return entitlement?.enabled === true;
}
